import { SystemApi } from '@/api/system';
import SystemStore from '@/store/system';
import { StoreService } from '@/services/store-service';

export class SystemService {
    constructor(client, store, router) {
        this.api = new SystemApi(client);
        this.store = StoreService.new(store, SystemStore);
        this.router = router;
    }

    async list(siteID) {
        const cachedSiteID = this.store.get('siteID');
        if (cachedSiteID != siteID) {
            const response = await this.api.list(siteID);
            var systems = response.systems;
            var result = [];
            if(Array.isArray(systems)){
                result = systems.filter(el => {
                    return el.systemStatus != 'Retired';
                })
    
                await this.store.dispatch('siteID', siteID);
                await this.store.dispatch('systems', result);
            }
            return result;
        } else {
            const cachedItems = this.store.get('systems');
            if (cachedItems) return cachedItems;
        }
    }

    async getSystem(id) {
        if (this.store.get('system') != null && id == this.store.get('system').id) {
            const cachedItems = this.store.get('system');
            if (cachedItems) return cachedItems;
        }

        const response = await this.api.getSystem(id);
        await this.store.dispatch('system', response.system);

        return response.system;
    }

    async getSystemServiceContracts(systemID) {
        const response = await this.api.getSystemServiceContracts(systemID);
        return response;
    }

    async getSystemWorkOrders(systemID) {
        const response = await this.api.getSystemWorkOrders(systemID);
        return response;
    }
}